import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { PasswordField, SButton, SContainer, SError, SParagraph, STitle } from "../../components/BasicComponents";
import AppNavbar from "../../components/Navbars/AppNavbar";
import { AuthContext } from "../../context/AuthContext";
import { toastSuccess } from "../../utils/Toast";
import Loading from "../../components/Loading/Loading";
import { te } from "../../utils/errorsTranslation";

const ResetPasswordPage = (props) => {
  const { t } = useTranslation("", { keyPrefix: "auth.reset_password" });

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetPswError, setResetPswError] = useState("");

  const { resetPassword, loading, error, resetError } = useContext(AuthContext);
  const history = useHistory();

  const onSubmit = (e) => {
    e.preventDefault();

    setResetPswError("");
    if (password !== confirmPassword) {
      setResetPswError(t("errors.passwords_match"));
    } else {
      if (props.match.path === "/reset-password/:resetPasswordToken") {
        const resetPasswordToken = props.match.params.resetPasswordToken;

        resetPassword(resetPasswordToken, password).then((res) => {
          if (res) {
            history.push("/login");
            setResetPswError("");
            toastSuccess(t("toast.password"));
          }
        });
      } else {
        setResetPswError(t("reset"));
      }
    }
  };

  useEffect(() => {
    return () => resetError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <SContainer dark="true" fluid fill="true" className="d-flex flex-column">
          <Row>
            <AppNavbar dark="true" />
          </Row>

          <Container className="m-auto">
            <Col xl={4} lg={5} md={8} sm={10} className="d-flex flex-column flex-grow-1 justify-content-center">
              <STitle className="fs-1 fw-bolder mb-4 p-2">{t("title")}</STitle>
              <SParagraph className="w-100 text-center mt-1 mb-0">{t("subtitle")}</SParagraph>
              <Form onSubmit={onSubmit} className="p-2">
                <Form.Group className="p-2">
                  <PasswordField onChange={(e) => setPassword(e.target.value)} />
                  <PasswordField onChange={(e) => setConfirmPassword(e.target.value)} />

                  <SButton type="submit" dark="true" className="mt-4 w-100 fs-5">
                    {t("confirm")}
                  </SButton>
                  {resetPswError && <SError>{resetPswError}</SError>}
                  {error && <SError className="mt-3">{te(error.message)}</SError>}
                </Form.Group>
              </Form>
            </Col>
          </Container>
        </SContainer>
      )}
    </>
  );
};

export default ResetPasswordPage;
